import { ISegment } from '@vtbhome/juicyfront/types';
import React, { useMemo } from 'react';
import { StyledBadge, TabLabel } from './segment-tabs.styles';
import { Typography } from '../typography/typography';
import { Segment } from '@vtbhome/juicyfront';
import { SegmentTabsProps } from './types';

export const SegmantTabs: React.FC<SegmentTabsProps> = ({ list, activeTabValue, onChange }) => {
    const activeTab = useMemo(() => {
        return list.find((tab) => tab.value === activeTabValue);
    }, [activeTabValue]);

    const segments: ISegment[] = useMemo(() => {
        return list.map((item) => ({
            label: (
                <TabLabel>
                    <Typography size='button1' color={item.value === activeTab?.value ? 'neutral_90' : 'neutral_50'}>
                        {item.title}
                    </Typography>
                    {item.badge && (
                        <StyledBadge
                            size='s'
                            variant={item.value === activeTab?.value ? 'info' : 'white'}
                            badgeContent={item.badge.text}
                            max={item.badge.max}
                        />
                    )}
                </TabLabel>
            ),
            value: item.value,
        }));
    }, [activeTab, list]);

    const activeSegment = useMemo(() => {
        return segments.find((segment) => segment.value === activeTab?.value);
    }, [segments, activeTab?.value]);

    const handleChange = (segment: ISegment) => {
        onChange(segment.value);
    };

    return <Segment list={segments} value={activeSegment} onChange={handleChange} />;
};
